<template>
  <div class="w-full">
    <!-- No Tithing History , No BF History -->
    <div v-if="tithingState === 0">
      <a
        @click="gotoTitheFirstTimeMsg()"
        class="flex flex-row bg-[#F0EAE0] w-full h-[120px] items-center rounded-[16px] border-[1px] border-[#A2A2A2]"
      >
        <p
          class="font-[700] text-[#393333] pl-[20%] text-[1rem] md:text-[1.75rem] lg:text-[1.875rem]"
        >
          Tithing
        </p>
        <img src="/assets/icons/my-giving/TithingCommitment_HOGCAPP.svg" class="pl-[24px]" />
      </a>
    </div>
    <!-- No Tithing History , Have BF History -->
    <div
      v-else-if="tithingState === 1"
      class="flex flex-row gap-[16px] justify-between h-[192px] md:h-[220px] lg:h-[240px]"
    >
      <a
        @click="gotoTitheFirstTimeMsg()"
        class="flex-1 flex flex-col bg-[#F0EAE0] items-center rounded-[16px] pt-[16px] border-[1px] border-[#A2A2A2] justify-between gap-[8px]"
      >
        <p
          class="font-[700] text-[#393333] text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] text-center"
        >
          Tithing
        </p>
        <img src="/assets/icons/my-giving/TithingCommitment_HOGCAPP.svg" class="mx-auto" />
      </a>
      <a
        @click="gotoBFHistory()"
        class="flex-1 flex-col bg-[#F0EAE0] items-center rounded-[16px] pt-[16px] border-[1px] border-[#A2A2A2]"
      >
        <p
          class="font-[700] text-[#393333] text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] text-center"
        >
          My BF <br />Fulfilment
        </p>
        <img src="/assets/icons/my-giving/bfFulfilment_HOGCAPP.svg" class="mx-auto" />
      </a>
    </div>
    <!-- Have Tithing History, No BF History -->
    <div v-else-if="tithingState === 2">
      <a
        @click="gotoTitheHistory()"
        class="flex flex-row bg-[#F0EAE0] w-full h-[120px] items-center rounded-[16px] border-[1px] border-[#A2A2A2]"
      >
        <p
          class="font-[700] text-[#393333] pl-[20%] text-[1rem] md:text-[1.75rem] lg:text-[1.875rem]"
        >
          My Tithing <br />
          &nbsp;&nbsp;History
        </p>
        <img src="/assets/icons/my-giving/TithingHistory_HOGCAPP.svg" class="pl-[24px]" />
      </a>
    </div>
    <!-- Have Tithing History, Have BF History -->
    <div
      v-else-if="tithingState === 3"
      class="flex flex-row gap-[16px] justify-between h-[192px] md:h-[220px] lg:h-[240px]"
    >
      <a
        @click="gotoTitheHistory()"
        class="flex-1 flex-col bg-[#F0EAE0] items-center rounded-[16px] pt-[16px] border-[1px] border-[#A2A2A2]"
      >
        <p
          class="font-[700] text-[#393333] text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] text-center"
        >
          My Tithing<br />History
        </p>
        <img src="/assets/icons/my-giving/TithingHistory_HOGCAPP.svg" class="mx-auto" />
      </a>
      <a
        @click="gotoBFHistory()"
        class="flex-1 flex-col bg-[#F0EAE0] items-center rounded-[16px] pt-[16px] border-[1px] border-[#A2A2A2]"
      >
        <p
          class="font-[700] text-[#393333] text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] text-center"
        >
          My BF <br />Fulfilment
        </p>
        <img src="/assets/icons/my-giving/bfFulfilment_HOGCAPP.svg" class="mx-auto" />
      </a>
    </div>
  </div>
  <!-- TODO replace hrefs -->
</template>
<script>
export default {
  props: {
    titheYears: {
      type: Array,
    },
    bfPledgeYears: {
      type: Array,
    },
    tithingState: {
      type: Number,
    },
  },
  methods: {
    gotoTitheHistory() {
      this.$router.push('/my-giving/tithe-history/' + this.titheYears.at(0));
    },
    gotoBFHistory() {
      this.$router.push('/my-giving/building-fund/' + this.bfPledgeYears.at(0));
    },
    gotoTitheFirstTimeMsg() {
      this.$router.push('/my-giving/tithe-first-time');
    },
  },
};
</script>
<style scoped>
* {
  font-family: 'Inter';
}
</style>
